import { Box, Skeleton } from '@mui/material'

export const LoadingSkeletons: React.FC = () => {
    return (
        <Box display="flex" flexDirection="column">
            <Box
                sx={{
                    backgroundColor: '#FFF',
                    display: 'flex',
                    borderTop: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Box
                    sx={{
                        py: 2,
                        pl: 2,
                        pr: 1,
                        flex: 1,
                        borderRight: '1px solid',
                        borderColor: 'grey.200',
                        alignItems: 'center'
                    }}
                >
                    <Skeleton width="80px" />
                </Box>

                <Box sx={{ flex: 2, py: 2, px: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                    <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                    <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                </Box>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#FFF',
                    display: 'flex',
                    borderTop: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Box
                    sx={{
                        py: 2,
                        pl: 2,
                        flex: 1,
                        borderRight: '1px solid',
                        borderColor: 'grey.200',
                        alignItems: 'center'
                    }}
                >
                    <Skeleton width="80px" />
                </Box>

                <Box sx={{ flex: 2, py: 2, px: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                    <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                    <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                </Box>
            </Box>
        </Box>
    )
}